import { render, staticRenderFns } from "./RidersView.vue?vue&type=template&id=3ac13194"
import script from "./RidersView.vue?vue&type=script&lang=js"
export * from "./RidersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports